import { useState, useEffect } from 'react';
import './machine_css.css';
import NaviBar from './NaviBar/NaviBar';
import HomeProduct from './homeProduct/homeProduct';
import SearchBar from './NaviBar/SearchBar';
import HomeBrand from './homeProduct/HomeBrand';
import HomeCate from './homeProduct/HomeCategory';
import BottomCard from './ShoppingCart/BottomCart';
import buy_now from '../Icons/buy_now.png';
import Draggable from 'react-draggable';
import QRModal from './items/QRModal';

function Home(props) {
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  const {
    cart,
    prods,
    add,
    decreStock,
    changeProdPrice,
    alterquantity,
    itemCounter,
    langs,
    remove,
    setShowCart,
    showCart,
    setlangs,
  } = props;

  const machine = JSON.parse(localStorage.getItem('machine'));
  const qrcode = machine?.themeColor?.allBrand;

  const [drag, setDrag] = useState(false);
  const [showQR, setShowQR] = useState(false);

  const QRpage = () => {
    setShowQR(true);
  };

  useEffect(() => {
    return () => {
      setDrag(true);
    };
  }, []);

  return (
    <div className="main-container">
      {showQR && (
        <QRModal
          show={showQR}
          setShow={setShowQR}
          code={qrcode}
          machine={machine}
          isLocal={isLocal}
        />
      )}
      {qrcode && (
        <Draggable
          axis="both"
          handle=".handle"
          defaultPosition={{ x: 0, y: 925 }}
          position={null}
          grid={[25, 25]}
          scale={1}
          onClick={QRpage}
          onDrag={() => {
            setDrag(true);
          }}
          onStop={() => {
            const stage = drag;
            setDrag(false);
            if (!stage) {
              QRpage();
            }
          }}
        >
          {!showQR ? (
            <div className="d-flex handle floating_button">
              <img className="" src={buy_now} alt=""></img>
            </div>
          ) : (
            <div></div>
          )}
        </Draggable>
      )}
      <div className="Navi"></div>
      <NaviBar setShowCart={setShowCart} setlangs={setlangs} cart={cart} langs={langs} />
      <SearchBar langs={langs} />

      <HomeProduct
        prods={prods}
        langs={langs}
        cart={cart}
        add={add}
        decreStock={decreStock}
        alterquantity={alterquantity}
        remove={remove}
        isLocal={isLocal}
      />
      <HomeBrand prods={prods} langs={langs} isLocal={isLocal} />
      <HomeCate prods={prods} langs={langs} />
      <BottomCard
        cart={cart}
        setShowCart={setShowCart}
        showCart={showCart}
        prods={prods}
        langs={langs}
        add={add}
        decreStock={decreStock}
        alterquantity={alterquantity}
        remove={remove}
        isLocal={isLocal}
      />
      {showCart && <div></div>}
    </div>
  );
}
export default Home;
